import { React, createRef, Component } from "react";
//import { Component } from "react";
import CreateIcon from "@material-ui/icons/Create";
import { ValidateEmail, normalize } from "../../../config/utility";
import { connect } from "react-redux";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import { addSettings, addMsaInfo } from "../../../actions";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {
  listSubUsers,
  getSingleUser,
  editSubUser,
  sendSubUserInvite,
  deleteInviteUser,
  listInvitedUsers,
  listUserRolesNew,
  getInviteAdminEmailPreview,
} from "./../../../config/api_calls";
import { getCustomSettings } from "./../../../config/reseller_api_calls";
import { getMenuGroupsAndRoles } from "../../../config/general_api_calls";
import HelperClass from "./../../../config/helperClass";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import PageTitle from "../ExtraComponents/PageTitle";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import StepWizard from "react-step-wizard";
import { CopyToClipboard } from "react-copy-to-clipboard";
import MutextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import dateFormat, { masks } from "dateformat";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import Tooltip from "@material-ui/core/Tooltip";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import countryList from "react-select-country-list";
import Select from "react-select";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import PasswordStrengthBar from "react-password-strength-bar";

import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();
class SubUsers extends Component {
  constructor() {
    super();
    this.state = {
      tableData: [],
      tableDataInvite: [],
      editUserData: [],
      c_password: "",
      errorMessage: "",
      errorMessageEdit: "",
      agentId: "",
      successMessage: "",
      successMessageEdit: "",
      eSuccessMessage: "",
      eErrorMessage: "",
      waitMessage: "",
      tableLoader: true,
      name: "",
      comp_name: "",
      title: "",
      email: "",
      password: "",
      errorEmail: false,
      errorPass: false,
      errorcPass: false,
      errorName: false,
      errorMessage: "",
      errorCompName: false,
      errorTitle: false,
      disabled: false,
      successMessage: "",
      errorConfirm: false,
      disableResendBtn: false,
      phone: "",
      user_id: "",
      account_status: "",
      admin_type: "",
      errorPhone: false,
      agent_id: "",
      serviceData: [],
      signedData: [],
      unsignedData: [],
      isEmailSending: false,
      unsigned_email_agreement_id: 0,
      revoke_reason: "",
      isRevokeReasonActive: false,
      subuser_email: "",
      subuser_name: "",
      subuserErrorMessage: "",
      subuserSuccessMessage: "",
      passwordShown: false,
      confirmPasswordShown: false,
      subuser_title: "",
      invitation_comment: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      errorAddress: false,
      errorCity: false,
      errorState: false,
      errorZip: false,
      errorCountry: false,
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      notifyCheckBox: false,
      allMenu: [],
      selectedRoles: {},
      savedRoles: [],
      showAssignRoles: false,
      previewType: "",
      address_autocomplete: true,
      address_validation: true,
      required_sub_user_type: false,
      listMenuGroupData: [],
      columnServices: [
        { name: "Title" },
        { name: "Company Name" },
        { name: "Email" },
        {
          name: "Phone",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setPhone(value, tableMeta)}</div>;
            },
          },
        },

        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setDomain(value, tableMeta)}</div>;
            },
          },
        },

        // {
        //   name: "Action",
        //   options: {
        //     customBodyRender: (value, tableMeta, updateValue) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     title="Other Actions"
        //                     className="dropdown-toggle btn btn-icon  btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           style={{ cursor: "pointer" }}
        //                           onClick={() =>
        //                             this.editUserForm(value, tableMeta)
        //                           }
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Edit Sub User"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-edit"></em>
        //                           <span>Edit Sub User</span>
        //                         </a>
        //                       </li>
        //                       <li>
        //                         <a
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.addMenuHistory(
        //                               "/sub_users/user_roles/" + value
        //                             )
        //                           }
        //                           title="Add / Edit User Roles"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-file-docs"></em>
        //                           <span>User Roles</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Action",
          label: "Action",
          options: {
            customBodyRender: (value, tableMeta) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const disabledMsg =
                "Action disabled because MSA is not signed or default settings are missing.";

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minHeight: 36,
                  }}
                >
                  {/* Edit Sub User */}
                  <Tooltip
                    title={isDisabled ? disabledMsg : "Edit Sub User"}
                    placement="top"
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled) this.editUserForm(value, tableMeta);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-edit text-primary"
                        style={{ fontSize: 20 }}
                      />
                    </span>
                  </Tooltip>

                  {/* User Roles */}
                  <Tooltip
                    title={isDisabled ? disabledMsg : "Edit Sub User Roles"}
                    placement="top"
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled)
                          this.addMenuHistory("/sub_users/user_roles/" + value);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-grid-alt text-info"
                        style={{
                          fontSize: 20,
                          paddingLeft: 5,
                          borderLeft: "1px solid rgb(0 0 0 / 87%)",
                        }}
                      />
                    </span>
                  </Tooltip>
                </div>
              );
            },
          },
        },
      ],
      columnServicesInvite: [
        { name: "ID" },
        { name: "Name" },
        { name: "Email" },
        { name: "Title" },
        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "Comment",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div onClick={() => this.commentModal(value, tableMeta)}>
                  <span
                    className="badge badge-outline-secondary"
                    style={{ cursor: "pointer" }}
                  >
                    View
                  </span>
                </div>
              );
            },
          },
        },
        // {
        //   name: "Actions",
        //   options: {
        //     customBodyRender: (value, tableMeta) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     className="dropdown-toggle btn btn-icon btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           onClick={() =>
        //                             this.deleteAlert(tableMeta.rowData[0])
        //                           }
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Delete Agreement"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-trash"></em>
        //                           <span>Delete User</span>
        //                         </a>
        //                       </li>
        //                       <li>
        //                         <a
        //                           onClick={() =>
        //                             this.resendActication(
        //                               tableMeta.rowData[1],
        //                               tableMeta.rowData[2],
        //                               tableMeta.rowData[3],
        //                               tableMeta.rowData[5]
        //                             )
        //                           }
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Resend Activation"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-signin"></em>
        //                           <span>Resend Activation</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Actions",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const disabledMsg =
                "Action disabled because MSA is not signed or default settings are missing.";

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minHeight: 36,
                  }}
                >
                  {/* Delete User */}
                  <Tooltip
                    title={isDisabled ? disabledMsg : "Delete User"}
                    placement="top"
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled) {
                          this.deleteAlert(tableMeta.rowData[0]);
                        }
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-trash text-danger"
                        style={{ fontSize: 20 }}
                      />
                    </span>
                  </Tooltip>

                  {/* Resend Activation */}
                  <Tooltip
                    title={isDisabled ? disabledMsg : "Resend Activation"}
                    placement="top"
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled) {
                          this.resendActication(
                            tableMeta.rowData[1],
                            tableMeta.rowData[2],
                            tableMeta.rowData[3],
                            tableMeta.rowData[5],
                          );
                        }
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                        borderLeft: "1px solid rgb(0 0 0 / 87%)",
                        paddingLeft: 5,
                      }}
                    >
                      <em
                        className="icon ni ni-signin text-primary"
                        style={{ fontSize: 20 }}
                      />
                    </span>
                  </Tooltip>
                </div>
              );
            },
          },
        },
      ],
    };
    this.countryOptions = countryList()
    .getData()
    .sort((a, b) => {
      if (a.label === "United States") return -1;  // US always first
      if (b.label === "United States") return 1;
      return a.label.localeCompare(b.label);
    });
  }

  async componentDidMount() {
    const servicesResponce = await listSubUsers(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        //tableDataInvite: servicesResponce.data.dataInvite,
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
    this.listUserRolesNew();
    this.getCustomSettings();
    this.getMenuGroupsAndRoles();

    window.$("#modalAssignRole").on("hidden.bs.modal", () => {
      window.$("#modalAddNewSubUser").modal("hide");
      setTimeout(() => {
        window.$("#modalAddNewSubUser").modal("show");
      }, 500);
    });
  }

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  listUserRolesNew = async () => {
    this.setState({
      tableLoader: true,
    });
    const servicesResponce = await listUserRolesNew(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("listUserRolesNew: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        allMenu: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  setPhone = (value, tableMeta) => {
    if (tableMeta.rowData[3] !== "") {
      let phone = this.formatPhoneNumber(tableMeta.rowData[3]);
      return phone;
    } else {
      return "---";
    }
  };

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  getInvitationUser = async () => {
    this.setState({
      tableLoader: true,
    });
    const servicesResponce = await listInvitedUsers(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableDataInvite: servicesResponce.data.dataInvite,
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  commentModal = (value, tableMeta) => {
    let invitation_comment = tableMeta.rowData[5];
    this.setState(
      {
        invitation_comment: invitation_comment,
      },
      () => {
        window.$("#modalInvitationComment").modal("show");
      },
    );
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM TT");
  };

  deleteAlert = async (value) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let id = value;
    this.setState({
      delete_id: id,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteInvitedUser = async () => {
    let user_id = this.state.delete_id;
    const userResponce = await deleteInviteUser(
      auth.getAccount(),
      auth.getToken(),
      user_id,
    );

    // console.log("deleteUsert: ", userResponce.data);
    //$("#btnloader").show();
    if (
      userResponce.data.status === 403 ||
      userResponce.data.errors === "authentication missing" ||
      userResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      userResponce.data.status === 404 &&
      userResponce.data.message === "fail" &&
      userResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessage: userResponce.data.note,
        successMessaged: "",
        disabled: false,
      });
      //$("#btnloader").hide();
    } else if (
      userResponce.data.status === 200 &&
      userResponce.data.message === "success"
    ) {
      //await this.reLoadClients();
      this.setState({
        errorMessage: "",
        successMessage: "Invited User deleted successfully.",
        disabled: false,
      });

      setTimeout(function () {
        window.location.reload();
        window.$("#modalDeleteAlert").modal("hide");
      }, 3000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        errorMessage: userResponce.data.message,
        successMessaged: "",
        disabled: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  editUserForm = async (value, tableMeta) => {
    let agent_id = tableMeta.rowData[6];
    const servicesResponce = await getSingleUser(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let admin_type = "";
      if (
        !servicesResponce.data.data[0]["admin_type"] ||
        servicesResponce.data.data[0]["admin_type"] === ""
      ) {
        admin_type = "No";
      } else if (servicesResponce.data.data[0]["admin_type"] === "Yes") {
        admin_type = "Yes";
      } else if (servicesResponce.data.data[0]["admin_type"] === "No") {
        admin_type = "No";
      }
      this.setState({
        user_id: servicesResponce.data.data[0]["id"],
        name: servicesResponce.data.data[0]["name"],
        comp_name: servicesResponce.data.data[0]["comp_name"],
        title: servicesResponce.data.data[0]["title"],
        email: servicesResponce.data.data[0]["email"],
        phone: servicesResponce.data.data[0]["phone"],
        account_status: servicesResponce.data.data[0]["account_status"],
        admin_type: admin_type,
        address: servicesResponce.data.data[0]["address"],
        address2: servicesResponce.data.data[0]["address2"],
        city: servicesResponce.data.data[0]["city"],
        state: servicesResponce.data.data[0]["state"],
        zip: servicesResponce.data.data[0]["zip"],
        country: servicesResponce.data.data[0]["country"],
        tableLoader: false,
      });
      window.$("#modalFormDetail").modal("show");
    } else {
      // window.location.replace("/error");
    }
  };

  setNewSubUserSettings = () => {
    // Clear form data first
    this.setState({
      subuserErrorMessage: "",
      subuserSuccessMessage: "",
      subuser_name: "",
      subuser_email: "",
      subuser_title: "",
      invitation_comment: "",
      savedRoles: [],
      selectedRoles: {},
      selected_group_id: "",
      showAssignRoles: false,
    });

    // Find and auto-select default group
    if (
      this.state.listMenuGroupData &&
      this.state.listMenuGroupData.length > 0
    ) {
      const defaultGroup = this.state.listMenuGroupData.find(
        (group) => group[6] === "Yes", // group[6] is is_default
      );

      if (defaultGroup) {
        // Auto-select the default group
        const defaultGroupId = defaultGroup[4].toString(); // group[4] is the ID

        // Set the default group and auto-populate roles
        this.setState(
          {
            selected_group_id: defaultGroupId,
            // showAssignRoles: true,
          },
          () => {
            // Trigger role population after state is set
            this.autoPopulateRolesForGroup(defaultGroup);
          },
        );
      }
    }

    // Show modal
    window.$("#modalAddNewSubUser").modal("show");
  };

  // Helper function to populate roles for a selected group
  autoPopulateRolesForGroup = (selectedGroup) => {
    if (selectedGroup && selectedGroup[5]) {
      // selectedGroup[5] is the roleIds array
      const roleIds = selectedGroup[5];
      let newSelectedRoles = {};
      let newSavedRoles = [];

      // Loop through all main roles and sub roles to check which ones should be selected
      this.state.allMenu.forEach((role, roleIndex) => {
        // Check if main role should be selected
        const isMainRoleSelected = roleIds.includes(role.id);

        if (isMainRoleSelected) {
          // Check main role
          newSelectedRoles[`main_tab${roleIndex}`] = true;

          // Build savedRoles entry for this main role
          let roleData = {
            mainRole: role.alt,
            subRoles: [],
          };

          // If main role is selected, check ALL its sub-roles
          if (role.subroles && role.subroles.length > 0) {
            role.subroles.forEach((subrole, subIndex) => {
              newSelectedRoles[`sub_tab${roleIndex}_${subIndex}`] = true;
              roleData.subRoles.push(subrole.alt);
            });
          }

          newSavedRoles.push(roleData);
        } else {
          // If main role is not selected, check individual sub-roles
          if (role.subroles && role.subroles.length > 0) {
            let hasSelectedSubRoles = false;
            let roleData = {
              mainRole: role.alt,
              subRoles: [],
            };

            role.subroles.forEach((subrole, subIndex) => {
              if (roleIds.includes(subrole.tabdetailid)) {
                newSelectedRoles[`sub_tab${roleIndex}_${subIndex}`] = true;
                roleData.subRoles.push(subrole.alt);
                hasSelectedSubRoles = true;
              }
            });

            // Only add to savedRoles if there are selected sub-roles
            if (hasSelectedSubRoles) {
              newSavedRoles.push(roleData);
            }
          }
        }
      });

      // Update both selectedRoles and savedRoles states
      this.setState({
        selectedRoles: newSelectedRoles,
        savedRoles: newSavedRoles,
      });
    }
  };

  // saveNewSubUser = async () => {
  //   const { subuser_name, subuser_email } = this.state;
  //   this.setState({
  //     subuserErrorMessage: "",
  //     subuserSuccessMessage: "",
  //     disabled: true,
  //   });

  //   if (subuser_name === "") {
  //     this.setState({
  //       subuserErrorMessage: "Please enter the name.",
  //       subuserSuccessMessage: "",
  //       disabled: false,
  //     });
  //   } else if (subuser_email === "") {
  //     this.setState({
  //       subuserErrorMessage: "Please enter the email address.",
  //       subuserSuccessMessage: "",
  //       disabled: false,
  //     });
  //   } else if (ValidateEmail(subuser_email) === false) {
  //     this.setState({
  //       subuserErrorMessage: "Please enter the valid email address.",
  //       subuserSuccessMessage: "",
  //       disabled: false,
  //     });
  //   } else {
  //     const servicesResponce = await sendSubUserInvite(
  //       auth.getAccount(),
  //       auth.getToken(),
  //       subuser_email,
  //       subuser_name
  //     );

  //     console.log("agentsResponce.data.data: ", servicesResponce.data);

  //     if (
  //       servicesResponce.data.status === 403 ||
  //       servicesResponce.data.errors === "authentication missing" ||
  //       servicesResponce.data.errors === "jwt expired"
  //     ) {
  //       auth.logout();
  //     } else if (servicesResponce.data.status === 404) {
  //       this.setState({
  //         subuserErrorMessage:
  //           "There is some error while sending invite to the user.",
  //         subuserSuccessMessage: "",
  //         disabled: false,
  //       });
  //     } else if (
  //       servicesResponce.data.status === 200 &&
  //       servicesResponce.data.message === "success"
  //     ) {
  //       this.setState(
  //         {
  //           subuserErrorMessage: "",
  //           subuserSuccessMessage: "Invite successfully sent to the user.",
  //           disabled: false,
  //         },
  //         () => {
  //           setTimeout(() => {
  //             window.location.reload();
  //           }, 3000);
  //         }
  //       );
  //     } else {
  //       this.setState({
  //         subuserErrorMessage:
  //           "There is some error while sending invite to the user.",
  //         subuserSuccessMessage: "",
  //         disabled: false,
  //       });
  //     }
  //   }
  //   setTimeout(() => {
  //     this.setState({
  //       subuserErrorMessage: "",
  //       subuserSuccessMessage: "",
  //     });
  //   }, 4000);
  // };

  saveNewSubUser = async () => {
    const {
      subuser_name,
      subuser_email,
      subuser_title,
      invitation_comment,
      savedRoles,
      selected_group_id,
      required_sub_user_type,
      listMenuGroupData,
    } = this.state;

    this.setState({
      subuserErrorMessage: "",
      subuserSuccessMessage: "",
      disabled: true,
    });
    const modalBody = document.getElementById("modalAddNewSubUser");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }
    if (subuser_name === "") {
      this.setState({
        subuserErrorMessage: "Please enter the name.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else if (subuser_title === "") {
      this.setState({
        subuserErrorMessage: "Please enter the title.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else if (subuser_email === "") {
      this.setState({
        subuserErrorMessage: "Please enter the email address.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else if (ValidateEmail(subuser_email) === false) {
      this.setState({
        subuserErrorMessage: "Please enter a valid email address.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else if (
      this.state.listMenuGroupData &&
      this.state.listMenuGroupData.length > 0 &&
      required_sub_user_type === "Yes" &&
      (!selected_group_id || selected_group_id === "")
    ) {
      this.setState({
        subuserErrorMessage: "Please select a sub user type.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else if (savedRoles.length === 0) {
      this.setState({
        subuserErrorMessage: "Please select the roles.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else if (invitation_comment === "") {
      this.setState({
        subuserErrorMessage: "Please enter the comment.",
        subuserSuccessMessage: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ subuserErrorMessage: "" });
      }, 3000);
    } else {
      const servicesResponce = await sendSubUserInvite(
        auth.getAccount(),
        auth.getToken(),
        subuser_email,
        subuser_name,
        subuser_title,
        invitation_comment,
        savedRoles,
      );

      // console.log("agentsResponce.data.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "Account already exists"
      ) {
        this.setState({
          subuserErrorMessage: "Sub user already registered with this email.",
          subuserSuccessMessage: "",
          disabled: false,
        });
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          subuserErrorMessage:
            "There is some error while sending invite to the user.",
          subuserSuccessMessage: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState(
          {
            subuserErrorMessage: "",
            subuserSuccessMessage:
              "Invite successfully sent to the user. Page will be refreshed automatically.",
            disabled: false,
          },
          () => {
            setTimeout(() => {
              //window.$("#modalAddNewSubUser").modal("hide");
              this.handleCloseModal();
              this.setState({
                subuserErrorMessage: "",
                subuserSuccessMessage: "",
              });
              window.location.reload();
            }, 3000);
          },
        );
      } else {
        this.setState({
          subuserErrorMessage:
            "There is some error while sending invite to the user.",
          subuserSuccessMessage: "",
          disabled: false,
        });
      }
    }
  };

  handleCloseModal = () => {
    // console.log("State before update:", this.state);
    this.setState({
      subuserErrorMessage: "",
      subuserSuccessMessage: "",
      subuser_name: "",
      subuser_email: "",
      subuser_title: "",
      invitation_comment: "",
    });
    // console.log("State after update:", this.state);
  };

  setDomain = (value, tableMeta) => {
    let domain_str = tableMeta.rowData[5];

    if (domain_str === "active") {
      return (
        <span className="badge badge-outline-success">
          Active
          <em className="icon ni ni-check-round-cut" title="Verified"></em>
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          Inactive
          <em className="icon ni ni-alert-circle" title="Verified"></em>
        </span>
      );
    }
  };

  show_email = () => {
    this.setState({
      send_email: "1",
    });
  };

  fieldValidation = () => {
    let {
      comp_name,
      name,
      title,
      email,
      address,
      city,
      state,
      zip,
      country,
      password,
      c_password,
      phone,
    } = this.state;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (comp_name === "") {
      this.setState({
        errorCompName: true,
        errorName: false,
        errorTitle: false,
        errorPhone: false,
        errorEmail: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Company Name is required.",
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (name === "") {
      this.setState({
        errorName: true,
        errorCompName: false,
        errorTitle: false,
        errorPhone: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Name is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (title === "") {
      this.setState({
        errorTitle: true,
        errorCompName: false,
        errorPhone: false,
        errorName: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Title is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (email === "") {
      this.setState({
        errorEmail: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorPhone: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorCountry: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Email is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (!ValidateEmail(email)) {
      this.setState({
        errorEmail: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorPhone: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorCountry: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Invalid email format.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (phone === "" || this.isPhoneValid(phone) === false) {
      this.setState({
        errorPhone: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Invalid phone number.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (!this.isPhoneValid(phone)) {
      this.setState({
        errorPhone: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorCountry: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Invalid phone number.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (address === "") {
      this.setState({
        errorAddress: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorPhone: false,
        errorCity: false,
        errorState: false,
        errorCountry: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Address is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (city === "") {
      this.setState({
        errorCity: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorAddress: false,
        errorPhone: false,
        errorState: false,
        errorCountry: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "CIty is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (state === "") {
      this.setState({
        errorState: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorPhone: false,
        errorCountry: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "State is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (zip === "") {
      this.setState({
        errorZip: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorPhone: false,
        errorAddress: false,
        errorCountry: false,
        errorCity: false,
        errorState: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Phone is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (country === "") {
      this.setState({
        errorCountry: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorPhone: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorPass: false,
        errorcPass: false,
        errorMessageEdit: "Country is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (c_password !== "" && password === "") {
      this.setState({
        errorPass: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorPhone: false,
        errorEmail: false,
        errorcPass: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorMessageEdit: "Password is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (password !== "" && !passwordRegex.test(password)) {
      this.setState({
        eerrorPass: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorPhone: false,
        errorEmail: false,
        errorcPass: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorMessageEdit:
          "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
      });
    } else if (password !== "" && c_password === "") {
      this.setState({
        errorcPass: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorPhone: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorEmail: false,
        errorPass: false,
        errorMessageEdit: "Confirm Password is required.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else if (password !== c_password) {
      this.setState({
        errorPass: true,
        errorcPass: true,
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorPhone: false,
        errorEmail: false,
        errorMessageEdit: "Password and confirm password do not match.",
      });
      setTimeout(() => this.setState({ errorMessageEdit: "" }), 3000);
      return false;
    } else {
      this.setState({
        errorCompName: false,
        errorName: false,
        errorTitle: false,
        errorEmail: false,
        errorPass: false,
        errorcPass: false,
        errorPhone: false,
        errorAddress: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        errorMessageEdit: "",
        disabled: true,
      });
      return true;
    }
  };

  formUpdateSubmit = async () => {
    let {
      name,
      email,
      password,
      phone,
      comp_name,
      title,
      user_id,
      account_status,
      address,
      address2,
      city,
      state,
      zip,
      country,
      admin_type,
    } = this.state;
    const modalBody = document.getElementById("modalFormDetail");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }
    if (this.fieldValidation() === true) {
      let apiResponce = await editSubUser(
        auth.getAccount(),
        auth.getToken(),
        name,
        email,
        password,
        phone,
        comp_name,
        title,
        user_id,
        account_status,
        address,
        address2,
        city,
        state,
        zip,
        country,
        this.state.notifyCheckBox.toString(),
        admin_type,
      );
      // console.log("Edit User RES: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessageEdit: formattedErrorMessage,
          tableLoader: false,
          disabled: false,
        });
        setTimeout(() => {
          this.setState({ successMessageEdit: "", errorMessageEdit: "" });
        }, 3000);
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessageEdit: "User updated successfully.",
          errorMessageEdit: "",
          tableLoader: false,
        });
        setTimeout(() => {
          this.setState({ successMessageEdit: "", errorMessageEdit: "" });
        }, 3000);
        setTimeout(() => {
          window.location.href = "/sub_users";
        }, 2000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        setTimeout(() => {
          this.setState({ successMessageEdit: "", errorMessageEdit: "" });
        }, 3000);
        return false;
      } else {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        setTimeout(() => {
          this.setState({ successMessageEdit: "", errorMessageEdit: "" });
        }, 3000);
        //auth.logout();
      }
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name, id } = target;

    let selectedRoles = { ...this.state.selectedRoles };
    let savedRoles = [...this.state.savedRoles];

    if (name === "main_role") {
      selectedRoles[id] = value;

      const roleIndex = id.replace("main_tab", "");

      if (value) {
        let roleData = {
          mainRole: this.state.allMenu[roleIndex].alt,
          subRoles: [],
        };

        this.state.allMenu[roleIndex].subroles.forEach((subrole, subIdx) => {
          const subRoleId = `sub_tab${roleIndex}_${subIdx}`;
          selectedRoles[subRoleId] = true;
          roleData.subRoles.push(subrole.alt);
        });

        savedRoles = savedRoles.filter(
          (role) => role.mainRole !== roleData.mainRole,
        );
        savedRoles.push(roleData);
      } else {
        this.state.allMenu[roleIndex].subroles.forEach((subrole, subIdx) => {
          const subRoleId = `sub_tab${roleIndex}_${subIdx}`;
          selectedRoles[subRoleId] = false;
        });
        savedRoles = savedRoles.filter(
          (role) => role.mainRole !== this.state.allMenu[roleIndex].alt,
        );
      }

      this.setState({ selectedRoles, savedRoles });
    } else if (name === "sub_role") {
      const [mainTabIndex, subTabIndex] = id.replace("sub_tab", "").split("_");
      const mainRoleKey = `main_tab${mainTabIndex}`;

      // FIX: Only allow sub-role to be checked if main role is checked
      if (value && !selectedRoles[mainRoleKey]) {
        // If trying to check a sub-role but main role is not checked, do nothing
        return;
      }

      selectedRoles[id] = value;

      let roleData = savedRoles.find(
        (role) => role.mainRole === this.state.allMenu[mainTabIndex].alt,
      );

      // FIX: If roleData doesn't exist, create it when checking a sub-role
      if (!roleData && value) {
        roleData = {
          mainRole: this.state.allMenu[mainTabIndex].alt,
          subRoles: [],
        };
        savedRoles.push(roleData);
      }

      if (roleData) {
        const subRoleName =
          this.state.allMenu[mainTabIndex].subroles[subTabIndex].alt;

        if (value) {
          if (!roleData.subRoles.includes(subRoleName)) {
            roleData.subRoles.push(subRoleName);
          }
        } else {
          roleData.subRoles = roleData.subRoles.filter(
            (subRole) => subRole !== subRoleName,
          );
        }

        // Remove roleData if no sub-roles are selected
        if (roleData.subRoles.length === 0) {
          savedRoles = savedRoles.filter(
            (role) => role.mainRole !== roleData.mainRole,
          );
        }
      }

      this.setState({ selectedRoles, savedRoles });
    } else {
      if (name === "name") {
        value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
      } else if (name === "comp_name") {
        value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
      } else if (name === "title") {
        value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
      }
      this.setState({
        [name]: value,
      });
    }
  };

  handleToggleAssignRoles = () => {
    this.setState({ showAssignRoles: !this.state.showAssignRoles });
  };

  formSave = () => {
    const selectedRoles = this.state.selectedRoles;
    const allSelected = [];

    this.state.allMenu.forEach((role, idx) => {
      const mainRoleId = `main_tab${idx}`;
      if (selectedRoles[mainRoleId]) {
        let roleData = {
          mainRole: role.alt,
          subRoles: [],
        };

        role.subroles.forEach((subrole, subIdx) => {
          const subRoleId = `sub_tab${idx}_${subIdx}`;
          if (selectedRoles[subRoleId]) {
            roleData.subRoles.push(subrole.alt);
          }
        });

        allSelected.push(roleData);
      }
    });

    const apiPayload = allSelected.map((role) => ({
      main_role: role.mainRole,
      sub_roles: role.subRoles,
    }));

    // console.log("API Payload:", apiPayload);

    this.setState({ savedRoles: allSelected }, () => {
      window.$("#modalAddNewSubUser").modal("hide");
      window.$("#modalAssignRole").modal("hide");
      setTimeout(() => {
        window.$("#modalAddNewSubUser").modal("show");
      }, 500);

      // console.log("Saved Roles:", this.state.savedRoles);
    });
  };

  modalOpenAssignRole = () => {
    window.$("#modalAssignRole").modal("show");
  };

  handleChangeRadio = (event) => {
    const { target } = event;
    const value = target.type === "radio" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  resendActication = async (
    subuser_name,
    subuser_email,
    subuser_title,
    invitation_comment,
  ) => {
    this.setState({
      subuserErrorMessage: "",
      subuserSuccessMessage: "",
      disabled: true,
    });

    const servicesResponce = await sendSubUserInvite(
      auth.getAccount(),
      auth.getToken(),
      subuser_email,
      subuser_name,
      subuser_title,
      invitation_comment,
    );

    window.$("#modalresendActivation").modal("show");

    // console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        subuserErrorMessage: "Error sending activation email.",
        subuserSuccessMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState(
        {
          subuserErrorMessage: "",
          subuserSuccessMessage: "Invitation email sent successfully.",
          disabled: false,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        },
      );
    } else {
      this.setState({
        subuserErrorMessage: "Error Sending Activation Email",
        subuserSuccessMessage: "",
        disabled: false,
      });
    }
  };

  modalHideResend = () => {
    window.$("#modalresendActivation").modal("hide");
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChangeCountry = (event) => {
    // console.log("event.label: ", event.label);
    const country = event.label;
    this.setState({
      country: country,
    });
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          city: city && city !== "" ? city : "",
          state: state && state !== "" ? state : "",
          zip: zipCode && zipCode !== "" ? zipCode : "",
          country: country && country !== "" ? country : "",
          address: streetAddress && streetAddress !== "" ? streetAddress : "",
          address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  preViewDefault = async (type) => {
    this.setState({
      previewType: type,
    });
    const getEmailResponse = await getInviteAdminEmailPreview(
      auth.getAccount(),
      auth.getToken(),
      type,
    );
    // console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0][6];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        if (type === "invite") {
          emailTemplate = emailTemplate.replace(
            /{{client_name}}/g,
            this.state.subuser_name || "{{client_name}}",
          );
          emailTemplate = emailTemplate.replace(
            /{{title}}/g,
            this.state.subuser_title || "{{title}}",
          );
          emailTemplate = emailTemplate.replace(
            /{{invitation_comment}}/g,
            this.state.invitation_comment || "{{invitation_comment}}",
          );
          emailTemplate = emailTemplate.replace(
            /{{comp_name}}/g,
            auth.getCompName() || "{{comp_name}}",
          );
        } else if (type === "edit") {
          emailTemplate = emailTemplate.replace(
            /{{client_name}}/g,
            this.state.name || "{{client_name}}",
          );
          emailTemplate = emailTemplate.replace(
            /{{client_email}}/g,
            this.state.email || "{{client_email}}",
          );
          emailTemplate = emailTemplate.replace(
            /{{invitation_comment}}/g,
            this.state.invitation_comment || "{{invitation_comment}}",
          );
          emailTemplate = emailTemplate.replace(
            /{{comp_name}}/g,
            auth.getCompName() || "{{comp_name}}",
          );
        }
        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    // First, actually close the preview modal
    window.$("#modalPreviewDefaultModal").modal("hide");

    if (this.state.previewType === "invite") {
      window.$("#modalAddNewSubUser").modal("hide");
      setTimeout(() => {
        window.$("#modalAddNewSubUser").modal("show");
      }, 500);
    }
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
          required_sub_user_type:
            getCustomSetting_res.data.data[0].required_sub_user_type || "No",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  getMenuGroupsAndRoles = async () => {
    this.setState({
      tableLoader: true,
    });
    const listClientMenuGroups = await getMenuGroupsAndRoles(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("Client Menu Groups: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      this.setState({
        listMenuGroupData: listClientMenuGroups.data.data,
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  handleGroupSelectionChange = (event) => {
    const selectedGroupId = event.target.value;

    // Update the selected_group_id state
    this.setState({ selected_group_id: selectedGroupId });

    if (selectedGroupId) {
      // Find the selected group data
      this.setState({ showAssignRoles: true });
      const selectedGroup = this.state.listMenuGroupData.find(
        (group) => group[4] === parseInt(selectedGroupId), // group[4] is the ID
      );

      if (selectedGroup && selectedGroup[5]) {
        // selectedGroup[5] is the roleIds array
        const roleIds = selectedGroup[5];
        let newSelectedRoles = {};
        let newSavedRoles = []; // FIX: Also build savedRoles for validation

        // Loop through all main roles and sub roles to check which ones should be selected
        this.state.allMenu.forEach((role, roleIndex) => {
          // Check if main role should be selected
          const isMainRoleSelected = roleIds.includes(role.id);

          if (isMainRoleSelected) {
            // Check main role
            newSelectedRoles[`main_tab${roleIndex}`] = true;

            // Build savedRoles entry for this main role
            let roleData = {
              mainRole: role.alt,
              subRoles: [],
            };

            // If main role is selected, check ALL its sub-roles
            if (role.subroles && role.subroles.length > 0) {
              role.subroles.forEach((subrole, subIndex) => {
                newSelectedRoles[`sub_tab${roleIndex}_${subIndex}`] = true;
                roleData.subRoles.push(subrole.alt); // Add to savedRoles
              });
            }

            newSavedRoles.push(roleData);
          } else {
            // If main role is not selected, check individual sub-roles
            if (role.subroles && role.subroles.length > 0) {
              let hasSelectedSubRoles = false;
              let roleData = {
                mainRole: role.alt,
                subRoles: [],
              };

              role.subroles.forEach((subrole, subIndex) => {
                if (roleIds.includes(subrole.tabdetailid)) {
                  newSelectedRoles[`sub_tab${roleIndex}_${subIndex}`] = true;
                  roleData.subRoles.push(subrole.alt);
                  hasSelectedSubRoles = true;
                }
              });

              // Only add to savedRoles if there are selected sub-roles
              if (hasSelectedSubRoles) {
                newSavedRoles.push(roleData);
              }
            }
          }
        });

        // Update both selectedRoles and savedRoles states
        this.setState({
          selectedRoles: newSelectedRoles,
          savedRoles: newSavedRoles, // FIX: Update savedRoles too
        });
      }
    } else {
      // If no group selected, clear all role selections
      this.setState({
        selectedRoles: {},
        savedRoles: [], // FIX: Also clear savedRoles
      });
    }
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Sub Users" icon="icon ni ni-user-list" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <Link
                              color="inherit"
                              onClick={() => this.setNewSubUserSettings()}
                              className="btn btn-primary"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                color: "#fff",
                              }}
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp;Add New Sub User
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade largeModalBox"
                tabIndex="-1"
                id="modalFormDetail"
              >
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-edit"></em> Edit Sub User
                      </h5>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* Error Start */}
                      {this.state.errorMessageEdit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageEdit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageEdit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageEdit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />
                      <div className="row g-4">
                        <form method="post" autoComplete="off" role="presentation" encType="multipart/form-data">
                          <div className="row g-4">
                            <div className="form-group col-md-4">
                              <MutextField
                                required
                                id="comp_name"
                                name="comp_name"
                                type="text"
                                label="Company Name"
                                inputProps={{ maxLength: 100 }}
                                value={this.state.comp_name}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorCompName}
                                helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                              autoComplete="new-password"
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                required
                                id="name"
                                name="name"
                                type="text"
                                label="Full Name"
                                inputProps={{ maxLength: 30 }}
                                value={this.state.name}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorName}
                                helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                              autoComplete="new-password"
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                required
                                id="title"
                                name="title"
                                type="text"
                                inputProps={{ maxLength: 30 }}
                                label="Title"
                                value={this.state.title}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorTitle}
                                helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                              autoComplete="new-password"
                              />
                            </div>

                            <div className=" col-md-4">
                              {/* <MutextField
                                id="phone"
                                name="phone"
                                type="text"
                                inputProps={{ maxLength: 14 }}
                                label="Phone"
                                value={this.state.phone}
                                onChange={this.handleChange}
                                onKeyPress={() => {
                                  this.checkNumber();
                                }}
                                variant="outlined"
                                fullWidth
                              autoComplete="new-password"
                              /> */}
                              <ReactPhoneInput
                                country="us"
                                value={this.state.phone}
                                onChange={(value) =>
                                  this.handleChange({
                                    target: {
                                      name: "phone",
                                      value: `+${value}`,
                                    },
                                  })
                                }
                                inputProps={{
                                  name: "phone",
                                  id: "phone",
                                  required: true,
                                  label: "Phone Number",
                                  maxLength: 20,
                                }}
                                specialLabel="Phone Number *"
                                containerStyle={{ width: "100%" }}
                                inputStyle={{ width: "100%", height: "56px" }}
                                isValid={!this.state.errorPhone}
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                required
                                id="email"
                                name="email"
                                type="email"
                                label="Email Address"
                                value={this.state.email}
                                onChange={this.handleChange}
                                variant="outlined"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              autoComplete="new-password"
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                required
                                id="account_status"
                                name="account_status"
                                select
                                label="Status"
                                value={this.state.account_status}
                                onChange={this.handleChange}
                                SelectProps={{
                                  native: true,
                                }}
                                variant="outlined"
                                fullWidth
                              autoComplete="new-password"
                              >
                                <option key="status1" value="active">
                                  Active
                                </option>
                                <option key="status0" value="inactive">
                                  Inactive
                                </option>
                              </MutextField>
                            </div>

                            <div className="form-group col-md-4">
                              <div
                                className="nk-block-between-md"
                                style={{
                                  position: "absolute",
                                  zIndex: 9999,
                                  right: "13px",
                                  top: "-15px",
                                }}
                              >
                                <div className="nk-block-head-content">
                                  <label
                                    htmlFor="googleLocation-autocomplete"
                                    style={{
                                      color: "black",
                                      fontWeight: "500",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {" "}
                                  </label>
                                </div>
                                {this.state.address_autocomplete === "Yes" && (
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools gx-3">
                                      <li>
                                        <a
                                          onClick={this.handleToggle}
                                          className="text-primary fs-11"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "11px",
                                          }}
                                        >
                                          {this.state.toggleButtonText}
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              {this.state.address_autocomplete === "Yes" ? (
                                this.state.useGooglePlaces ? (
                                  <GooglePlacesAutocomplete
                                    apiKey={
                                      process.env
                                        .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                    }
                                    apiOptions={{ loading: 'async' }}
                                    selectProps={{
                                      value: this.state.address
                                        ? {
                                          label: this.state.address,
                                          value: this.state.address,
                                        }
                                        : null,
                                      onChange: this.handleAddressSelect,
                                      placeholder: this.state.address
                                        ? null
                                        : "Enter your address..",
                                      styles: {
                                        input: (provided) => ({
                                          ...provided,
                                          color: "black",
                                          height: "47px",
                                        }),
                                        option: (provided) => ({
                                          ...provided,
                                          color: "black",
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          color: "black",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9,
                                        }),
                                      },
                                    }}
                                    className="googleLocation-autocomplete"
                                  />
                                ) : (
                                  <MutextField
                                    id="address"
                                    name="address"
                                    type="text"
                                    label="PO Box Address"
                                    value={this.state.address}
                                    onChange={this.handleChange}
                                    inputProps={{ maxLength: 100 }}
                                    variant="outlined"
                                    helperText="Please provide your complete address, excluding city, state, and zip."
                                    fullWidth
                                    error={this.state.errorAddress === "error"}
                                  autoComplete="new-password"
                                  />
                                )
                              ) : (
                                // address_autocomplete === "No" → show PO Box only
                                <MutextField
                                  id="address"
                                  name="address"
                                  type="text"
                                  label="Address"
                                  value={this.state.address}
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  helperText="Enter your address"
                                  fullWidth
                                  error={this.state.errorAddress === "error"}
                                autoComplete="new-password"
                                />
                              )}
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                id="address2"
                                name="address2"
                                type="text"
                                label="Address 2"
                                value={this.state.address2}
                                onChange={this.handleChange}
                                inputProps={{ maxLength: 100 }}
                                helperText="If needed, enter additional address details, such as apartment number, suite, or unit."
                                variant="outlined"
                                fullWidth
                              autoComplete="new-password"
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                id="city"
                                name="city"
                                type="text"
                                label="City"
                                value={this.state.city}
                                inputProps={{ maxLength: 30 }}
                                onChange={this.handleChange}
                                helperText=""
                                variant="outlined"
                                fullWidth
                                error={this.state.errorCity === "error"}
                              autoComplete="new-password"
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <MutextField
                                id="state"
                                name="state"
                                type="text"
                                label="State"
                                value={this.state.state}
                                inputProps={{ maxLength: 20 }}
                                onChange={this.handleChange}
                                helperText=""
                                variant="outlined"
                                fullWidth
                                error={this.state.errorState === "error"}
                              autoComplete="new-password"
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <MutextField
                                id="zip"
                                name="zip"
                                type="text"
                                label="Zip"
                                value={this.state.zip}
                                inputProps={{ maxLength: 10 }}
                                onChange={this.handleChange}
                                helperText=""
                                variant="outlined"
                                fullWidth
                                error={this.state.errorZip === "error"}
                              autoComplete="new-password"
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <Autocomplete
                                options={this.countryOptions}
                                getOptionLabel={(opt) => opt.label}
                                value={
                                  this.state.country
                                    ? this.countryOptions.find(opt => opt.label === this.state.country) || null
                                    : null
                                }
                                onChange={(e, newValue) =>
                                  this.handleChangeCountry(newValue || { label: "" })
                                }
                                renderInput={(params) => (
                                  <MutextField
                                    {...params}
                                    label="Country"
                                    variant="outlined"
                                    fullWidth
                                    error={this.state.errorCountry === "error"}
                                    helperText="Select country"
                                  autoComplete="new-password"
                                  />
                                )}
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <MutextField
                                id="password"
                                name="password"
                                type={
                                  this.state.passwordShown ? "text" : "password"
                                }
                                label="Password"
                                value={this.state.password}
                                inputProps={{ maxLength: 100 }}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorPass}
                                helperText="Password must be at least 8 characters, with
                                uppercase, lowercase, number & special
                                character."
                              autoComplete="new-password"
                              />
                              <a
                                style={{
                                  left: "auto",
                                  right: "15px",
                                  top: "42px",
                                  position: "absolute",
                                  cursor: "pointer",
                                }}
                                tabIndex="-1"
                                onClick={() => {
                                  this.togglePassword();
                                }}
                                className="form-icon form-icon-right passcode-switch"
                                data-target="password"
                              >
                                {this.state.passwordShown ? (
                                  <em className="icon ni ni-eye-off"></em>
                                ) : (
                                  <em className="icon ni ni-eye"></em>
                                )}
                              </a>
                              <div>
                                <PasswordStrengthBar
                                  password={this.state.password}
                                />
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <MutextField
                                id="c_password"
                                name="c_password"
                                type={
                                  this.state.confirmPasswordShown
                                    ? "text"
                                    : "password"
                                }
                                label="Confirm Password"
                                value={this.state.c_password}
                                inputProps={{ maxLength: 100 }}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorcPass}
                                helperText={`Confirm Password must be at least 8 characters,
                                with uppercase, lowercase, number & special
                                character. Confirm Password must match the
                                Password.`}
                              autoComplete="new-password"
                              />
                              <a
                                style={{
                                  left: "auto",
                                  right: "15px",
                                  top: "42px",
                                  position: "absolute",
                                  cursor: "pointer",
                                }}
                                tabIndex="-1"
                                onClick={() => {
                                  this.toggleConfirmPassword();
                                }}
                                className="form-icon form-icon-right passcode-switch"
                                data-target="password"
                              >
                                {this.state.confirmPasswordShown ? (
                                  <em className="icon ni ni-eye-off"></em>
                                ) : (
                                  <em className="icon ni ni-eye"></em>
                                )}
                              </a>
                            </div>
                            <div className="form-group col-md-4">
                              <MutextField
                                id="admin_type"
                                name="admin_type"
                                select
                                label="Subpoena User"
                                value={this.state.admin_type}
                                onChange={this.handleChange}
                                SelectProps={{
                                  native: true,
                                }}
                                variant="outlined"
                                fullWidth
                              autoComplete="new-password"
                              >
                                <option key="status111" value="Yes">
                                  Yes
                                </option>
                                <option key="status011" value="No">
                                  No
                                </option>
                              </MutextField>
                            </div>
                            <div className="col-md-12">
                              <p>
                                NOTE: Password is optional. If you do not want
                                to change the password, leave the last two
                                fields empty.
                              </p>
                            </div>
                            <div className="form-group col-md-6">
                              <div
                                className="custom-control custom-control-lg custom-checkbox"
                                style={{ padding: 0, marginLeft: "3rem" }}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customCheck2"
                                  onChange={() => {
                                    const isChecked =
                                      !this.state.notifyCheckBox;
                                    this.setState({
                                      notifyCheckBox: isChecked,
                                    });
                                    // console.log(
                                    //   "Notify Checkbox Checked:",
                                    //   isChecked
                                    // );
                                  }}
                                />

                                <label
                                  className="custom-control-label"
                                  for="customCheck2"
                                >
                                  Notify Sub User
                                </label>
                              </div>
                            </div>
                            <div
                              className="col-lg-12 no-padding-margin-preview"
                              style={{
                                padding: 0,
                                cursor: "pointer",
                                color: "#0066cc",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                this.preViewDefault("edit");
                              }}
                            >
                              <span>Preview Notification Email </span>
                            </div>
                            <div style={{ clear: "both" }}></div>
                            <hr />
                            <div className="form-group text-right col-md-12 mb-4">
                              <button
                                className="btn btn-lg btn-primary"
                                type="button"
                                disabled={this.state.disabled}
                                onClick={this.formUpdateSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>

                      {/* </form> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block">
                {/* Table 5th Col Start */}

                <div className="nk-block nk-block-lg">
                  <div className="row g-gs">
                    <div className="col-xxl-12">
                      <div className="nk-block nk-block-lg">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  data-toggle="tab"
                                  href="#adminEmails"
                                >
                                  <em className="icon ni ni-user-list"></em>
                                  <span>Sub Users</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  data-toggle="tab"
                                  href="#agentEmails"
                                  onClick={() => this.getInvitationUser()}
                                >
                                  <em className="icon ni ni-user-add"></em>
                                  <span>Invited Users</span>
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div className="tab-pane active" id="adminEmails">
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.columnServices}
                                    tableData={this.state.tableData}
                                    title="All Sub Users"
                                  />
                                )}
                              </div>
                              <div className="tab-pane" id="agentEmails">
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.columnServicesInvite}
                                    tableData={this.state.tableDataInvite}
                                    title="All Invited Users"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Table 5th Col End */}
                {/* New Sub User Modal Start */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalAddNewSubUser"
                >
                  <div
                    className="modal-dialog modal-dialog-top modal-xl"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={this.handleCloseModal}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <em
                            className="icon ni ni-user-add"
                            style={{ marginRight: "5px" }}
                          ></em>{" "}
                          Add New Sub User
                        </h5>
                      </div>
                      <div className="modal-body">
                        {this.state.formLoader === true ? (
                          FormLoader()
                        ) : (
                          <div className="row g-4">
                            {this.state.subuserErrorMessage !== "" ? (
                              <div className="col-md-12 mb-3">
                                <div
                                  className="example-alert example-alert-revoke"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>{this.state.subuserErrorMessage}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.subuserSuccessMessage !== "" ? (
                              <div className="col-md-12 mb-3">
                                <div
                                  className="example-alert example-alert-revoke"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>{this.state.subuserSuccessMessage}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="subuser_name"
                                    name="subuser_name"
                                    type="text"
                                    label="Full Name"
                                    value={this.state.subuser_name}
                                    inputProps={{ maxLength: 64 }}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-zA-Z\s'.,:\-()|!@]/gi,
                                        "",
                                      );
                                    }}
                                    helperText="Full name of the invite recipient."
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="subuser_title"
                                    name="subuser_title"
                                    type="text"
                                    label="Title"
                                    value={this.state.subuser_title}
                                    helperText="Title of the invite recipient."
                                    inputProps={{ maxLength: 30 }}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="subuser_email"
                                    name="subuser_email"
                                    type="text"
                                    label="Email Address"
                                    value={this.state.subuser_email}
                                    helperText="Email address of the invite recipient."
                                    inputProps={{ maxLength: 100 }}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.listMenuGroupData &&
                              this.state.listMenuGroupData.length > 0 && (
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="selected_group_id"
                                        name="selected_group_id"
                                        select
                                        label={
                                          this.state.required_sub_user_type ==
                                            "Yes" ? (
                                            <>
                                              Select Sub User Type{" "}
                                              <span>*</span>
                                            </>
                                          ) : (
                                            "Select Sub User Type"
                                          )
                                        }
                                        value={this.state.selected_group_id}
                                        onChange={
                                          this.handleGroupSelectionChange
                                        } // Use the new handler
                                        SelectProps={{
                                          native: true,
                                        }}
                                        helperText="Sub User Type"
                                        variant="outlined"
                                        fullWidth
                                        error={
                                          this.state.errorClientType === "error"
                                        }
                                      >
                                        <option
                                          key="group_default"
                                          value=""
                                        ></option>
                                        {this.state.listMenuGroupData &&
                                          this.state.listMenuGroupData.length >
                                          0 &&
                                          this.state.listMenuGroupData.map(
                                            (group, index) => (
                                              <option
                                                key={`group_${index}`}
                                                value={group[4]}
                                              >
                                                {group[1]}
                                              </option>
                                            ),
                                          )}
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>
                              )}

                            <div className="col-md-12">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <TextareaAutosize
                                    maxrows={4}
                                    name="invitation_comment"
                                    id="invitation_comment"
                                    aria-label=""
                                    placeholder="Add Comment *"
                                    maxLength={500}
                                    value={this.state.invitation_comment}
                                    helperText="Maximum 500 characters"
                                    onChange={this.handleChange}
                                    style={{
                                      width: "100%",
                                      height: "100px",
                                      borderColor: "rgba(0, 0, 0, 0.125)",
                                      borderRadius: "4px",
                                      padding: "5px",
                                    }}
                                    variant="outlined"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <h6
                                  className="overline-title-alt text-primary"
                                  style={{
                                    cursor: "pointer",
                                    clear: "both",
                                    fontSize: "0.8rem",
                                    marginBottom: !!this.state.selected_group_id
                                      ? "0px"
                                      : "20px",
                                  }}
                                  onClick={this.handleToggleAssignRoles}
                                >
                                  Assign Roles{" "}
                                  {this.state.showAssignRoles ? (
                                    <em className="icon ni ni-chevron-up"></em>
                                  ) : (
                                    <em className="icon ni ni-chevron-down"></em>
                                  )}
                                </h6>

                                {this.state.showAssignRoles && (
                                  <div className="table-responsive">
                                    {!!this.state.selected_group_id && (
                                      <div
                                        className="alert alert-info mt-3"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <em
                                          className="icon ni ni-info"
                                          style={{
                                            marginRight: "8px",
                                            fontSize: "1.1rem",
                                          }}
                                        ></em>
                                        <span style={{ fontSize: "0.85rem" }}>
                                          <strong>Group Selected:</strong> Roles
                                          are pre-configured for this group and
                                          cannot be modified. Clear the group
                                          selection to manually assign roles.
                                        </span>
                                      </div>
                                    )}
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Main Role</th>
                                          <th>Sub Roles</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.allMenu &&
                                          this.state.allMenu.length > 0 ? (
                                          this.state.allMenu.map(
                                            (role, idx) => (
                                              <tr key={`role${idx}`}>
                                                <td
                                                  style={{
                                                    width: "30%",
                                                    verticalAlign: "middle",
                                                  }}
                                                >
                                                  <div className="custom-control custom-checkbox">
                                                    <input
                                                      name="main_role"
                                                      type="checkbox"
                                                      className="custom-control-input vdrSelected"
                                                      id={`main_tab${idx}`}
                                                      value={role.id}
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      checked={
                                                        !!this.state
                                                          .selectedRoles[
                                                        `main_tab${idx}`
                                                        ]
                                                      }
                                                      disabled={
                                                        !!this.state
                                                          .selected_group_id
                                                      }
                                                    autoComplete="new-password" />
                                                    <label
                                                      className={`custom-control-label ${!!this.state
                                                          .selected_group_id
                                                          ? "text-muted"
                                                          : ""
                                                        }`}
                                                      htmlFor={`main_tab${idx}`}
                                                      style={{
                                                        cursor: !!this.state
                                                          .selected_group_id
                                                          ? "not-allowed"
                                                          : "pointer",
                                                      }}
                                                    >
                                                      {role.alt}
                                                    </label>
                                                  </div>
                                                </td>
                                                <td>
                                                  {role.subroles &&
                                                    role.subroles.length > 0 ? (
                                                    role.subroles.map(
                                                      (subrole, subIdx) => (
                                                        <div
                                                          className="custom-control custom-checkbox"
                                                          key={`subrole${subIdx}`}
                                                          style={{
                                                            marginRight: "25px",
                                                            marginBottom:
                                                              "15px",
                                                            marginTop: "10px",
                                                          }}
                                                        >
                                                          <input
                                                            name="sub_role"
                                                            type="checkbox"
                                                            className="custom-control-input vdrSelected2"
                                                            id={`sub_tab${idx}_${subIdx}`}
                                                            value={
                                                              subrole.tabdetailid
                                                            }
                                                            onChange={
                                                              this.handleChange
                                                            }
                                                            checked={
                                                              !!this.state
                                                                .selectedRoles[
                                                              `sub_tab${idx}_${subIdx}`
                                                              ]
                                                            }
                                                            disabled={
                                                              !!this.state
                                                                .selected_group_id
                                                            }
                                                          autoComplete="new-password" />
                                                          <label
                                                            className={`custom-control-label ${!!this.state
                                                                .selected_group_id
                                                                ? "text-muted"
                                                                : ""
                                                              }`}
                                                            htmlFor={`sub_tab${idx}_${subIdx}`}
                                                            style={{
                                                              cursor: !!this
                                                                .state
                                                                .selected_group_id
                                                                ? "not-allowed"
                                                                : "pointer",
                                                            }}
                                                          >
                                                            {subrole.alt}
                                                          </label>
                                                        </div>
                                                      ),
                                                    )
                                                  ) : (
                                                    <span className="text-muted">
                                                      ----
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                            ),
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan="2"
                                              className="text-center text-muted"
                                            >
                                              No roles available
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div
                              className="col-lg-12 no-padding-margin-preview"
                              style={{
                                padding: 0,
                                cursor: "pointer",
                                color: "#0066cc",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                this.preViewDefault("invite");
                              }}
                            >
                              <span>Preview Notification Email </span>
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                              <button
                                type="button"
                                onClick={() => this.saveNewSubUser()}
                                className="btn btn-primary"
                                disabled={this.state.disabled}
                              >
                                <span>Send Invite</span>{" "}
                                <em className="icon ni ni-emails"></em>
                              </button>
                            </div>
                            <div className="col-md-12">
                              <div className="example-alert">
                                <div className="alert alert-light">
                                  <ul className="list">
                                    <li>
                                      An email will be dispatched to the
                                      provided email address.
                                    </li>
                                    <li>
                                      This email will contain a secure,
                                      tokenized link for user registration.
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* New Sub User Modal End */}
                {/* MODAL EDIT PROFILE START */}
                <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <a
                        style={{ cursor: "pointer" }}
                        className="close"
                        onClick={() => {
                          this.modalHideDel();
                        }}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-body modal-body-lg text-center">
                        <div className="nk-modal">
                          <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                          <h4 className="nk-modal-title">
                            Delete Invited User?
                          </h4>
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="nk-modal-text">
                            <div className="caption-text">
                              Are you sure you want to delete this Invited User?
                            </div>
                          </div>
                          <div className="nk-modal-action">
                            <a
                              style={{ cursor: "pointer" }}
                              className="btn btn-lg btn-mw btn-primary"
                              onClick={() => {
                                this.modalHideDel();
                              }}
                            >
                              CANCEL
                            </a>
                            {"  "}
                            <a
                              style={{ cursor: "pointer" }}
                              className="btn btn-lg btn-mw btn-danger"
                              onClick={() => {
                                this.deleteInvitedUser();
                              }}
                            >
                              DELETE
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Resend Activation Modal Start */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalresendActivation"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      {this.state.subuserSuccessMessage && (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideResend();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                              <h4
                                className="nk-modal-title"
                                style={{ fontSize: "1.3rem" }}
                              >
                                {this.state.subuserSuccessMessage}
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.subuserErrorMessage && (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideResend();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                              <h4
                                className="nk-modal-title"
                                style={{ fontSize: "1.3rem" }}
                              >
                                {this.state.subuserErrorMessage}
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* Resend Activation Modal Ends */}

                {/* Modal Invitation Comment */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalInvitationComment"
                >
                  <div
                    className="modal-dialog modal-xl modal-dialog-top"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">Invitation Comments</h5>
                      </div>
                      <div className="modal-body">
                        <p className="text-dark">
                          {this.state.invitation_comment &&
                            this.state.invitation_comment !== ""
                            ? this.state.invitation_comment
                            : "No Comments"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Modal Invitation Comment */}
                {/* PREVIEW DEFAULT MODAL  */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalPreviewDefaultModal"
                  style={{ zIndex: "9999" }}
                >
                  <div
                    className="modal-dialog modal-dialog-top modal-xl"
                    role="document"
                  >
                    <div className="modal-content">
                      <div
                        className="modal-header"
                        style={{ borderBottom: "1px solid #e5e9f2" }}
                      >
                        <h5
                          className="modal-title"
                          style={{
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "700",
                            fontSize: "1.25rem",
                            color: "#364a63",
                          }}
                        >
                          Preview Notification Email
                        </h5>
                        <a
                          style={{ cursor: "pointer" }}
                          className="close"
                          onClick={() => this.closePreviewModal()}
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>
                      <div className="modal-body" style={{ padding: "1.5rem" }}>
                        <div className="nk-block">
                          <div className="card card-bordered">
                            <div className="card-inner">
                              <div
                                className="email-preview"
                                style={{
                                  maxHeight: "60vh",
                                  overflow: "auto",
                                  padding: "1rem",
                                  backgroundColor: "#f5f6fa",
                                  borderRadius: "4px",
                                }}
                              >
                                {this.state.isEditorReady ? (
                                  <div
                                    className="email-preview-content"
                                    style={{
                                      fontFamily: "'Roboto', sans-serif",
                                      fontSize: "14px",
                                      lineHeight: "1.65",
                                      pointerEvents: "none",
                                      userSelect: "none",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.email_template,
                                    }}
                                  />
                                ) : (
                                  tableLoader()
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="modal-footer"
                        style={{
                          borderTop: "1px solid #e5e9f2",
                          padding: "1rem 1.5rem",
                        }}
                      >
                        <button
                          onClick={() => this.closePreviewModal()}
                          className="btn btn-primary"
                          style={{
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "500",
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* PREVIEW DEFAULT MODAL  */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SubUsers);
